import { useRef, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { Noticia } from '../../typesSite/noticia/Noticia';
import useNoticiaSiteFetch from './useNoticiaSiteFetch';

type Props = {
  isdisabled?: boolean;
  isLoading?: boolean;
  required?: boolean;
  value?: Noticia | null;
  handleSearchChange: (newValue: Noticia) => void;
};

const TxtNoticiaSite = ({
  isdisabled,
  isLoading,

  required,
  value,
  handleSearchChange
}: Props) => {
  const timeoutRef = useRef<number | null>(null);
  const loading = useRef(false);

  const handleSetLoad = (newValue: boolean) => {
    loading.current = newValue;
  };

  const [inputValue, setInputValue] = useState('');
  const { options } = useNoticiaSiteFetch({ inputValue, handleSetLoad });

  return (
    <Autocomplete
      value={value && value.id ? value : null} //
      size="small"
      options={options}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={option => {
        const noticiaSite = option as Noticia;
        let descricao: string = '';
        if (!noticiaSite) {
          return '';
        }

        if (noticiaSite.titulo) {
          descricao = noticiaSite.titulo;
        }
        return descricao;
      }}
      loading={loading.current}
      onInputChange={(event, newInputValue) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          setInputValue(newInputValue);
        }, 700); // 300ms delay
      }}
      onChange={(event, newValue) => {
        handleSearchChange(newValue as Noticia);
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Notícia"
          required={required ? true : false}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading.current ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};
export default TxtNoticiaSite;
